var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.375 26.125H14.25C14.25 19 18.05 16.625 20.6625 15.2C21.6125 14.725 22.325 14.25 22.8 13.775C23.9875 12.5875 23.5125 10.925 23.275 10.45C22.5625 8.7875 20.9 7.125 17.8125 7.125C12.825 7.125 11.875 11.6375 11.875 12.5875L4.75 11.6375C5.225 7.6 8.7875 0 17.8125 0C23.275 0 28.025 3.0875 29.925 7.6C31.5875 11.6375 30.875 15.9125 28.025 18.7625C26.8375 19.95 25.4125 20.6625 24.225 21.375C22.0875 22.5625 21.375 23.75 21.375 26.125Z",
    fill: "#D7181D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5625 33.25C22.5625 35.8744 20.4369 38 17.8125 38C15.1881 38 13.0625 35.8744 13.0625 33.25C13.0625 30.6256 15.1881 28.5 17.8125 28.5C20.4369 28.5 22.5625 30.6256 22.5625 33.25Z",
    fill: "#D7181D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.0311506e2a77304b72a02e6ad346847f.svg";
export { ForwardRef as ReactComponent };